import { getEl } from '../helpers/helpers.js'
import {
	attachListeners,
	createState,
	observeThemeChanges,
	resizeCanvas,
	startLoop,
} from '../helpers/canvas.js'

export function initBackgroundCanvas() {
	const canvas = getEl('[data-canvas]')
	if (!canvas) {
		return
	}

	const state = createState(canvas)
	observeThemeChanges(state)
	resizeCanvas(state)
	startLoop(state)
	attachListeners(state)
}
